module.exports = __webpack_public_path__ + "img/popup_edit2.ed0414bc.png";